/* Estimated delivery date — countdown + placement.
 *
 * Liquid renders the sentence complete, so this only:
 *   1. moves the block next to the buy buttons (the section lives in the
 *      header group, like the rest of the Oshea PDP additions), and
 *   2. keeps the countdown and the dates honest against the shopper's own
 *      clock, which matters if the page was served from cache.
 *
 * Dates are formatted in the store's timezone, so a shopper abroad still sees
 * the delivery window the warehouse works to. The text is rewritten once a
 * minute at most.
 */
(() => {
  const TZ = 'Asia/Kolkata';
  const box = document.querySelector('[data-opd-eta]');
  if (!box) return;

  const place = () => {
    const blocks = document.querySelector('.product__info-container .product__blocks') || document.querySelector('.product__blocks');
    if (!blocks) return false;
    const anchor =
      blocks.querySelector('[id^="samita-countdown-"]') ||
      blocks.querySelector('.product__block--\\@app') ||
      blocks.querySelector('.product__block--buy_buttons');
    if (anchor && anchor.parentNode === blocks) blocks.insertBefore(box, anchor.nextSibling);
    else blocks.appendChild(box);
    box.hidden = false;
    return true;
  };

  const fmt = new Intl.DateTimeFormat('en-US', { timeZone: TZ, month: 'short', day: '2-digit' });
  const min = parseInt(box.dataset.min, 10);
  const max = parseInt(box.dataset.max, 10);
  const shift = parseInt(box.dataset.shift, 10) || 0;
  const leftEl = box.querySelector('[data-opd-eta-left]');
  const rangeEl = box.querySelector('[data-opd-eta-range]');
  let cutoff = parseInt(box.dataset.cutoff, 10);
  let lastLeft = '';
  let lastRange = '';

  /* Adding whole days to the current instant and formatting in the store's
     timezone gives the right calendar date there; India has no DST. */
  const dayAfter = (n) => fmt.format(new Date(Date.now() + (n - shift) * 86400000));

  const tick = () => {
    const now = Math.floor(Date.now() / 1000);
    while (cutoff <= now) cutoff += 86400;

    /* Minutes round up, to match the app and so the shopper is never told
       they have less time left than they really do. */
    const mins = Math.ceil((cutoff - now) / 60);
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    const leftText = (h > 0 ? h + ' Hrs ' : '') + String(m).padStart(2, '0') + ' Mins';
    if (leftText !== lastLeft) {
      lastLeft = leftText;
      leftEl.textContent = leftText;
    }

    const rangeText = dayAfter(min) + ' - ' + dayAfter(max);
    if (rangeText !== lastRange) {
      lastRange = rangeText;
      rangeEl.textContent = rangeText;
    }
  };

  const start = () => {
    if (!place()) return;
    tick();
    setInterval(tick, 30000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
